<template>
  <div class="ca-root">

    <!-- ═══ SIDEBAR ═══ -->
    <aside class="ca-sidebar">

      <div class="ca-header">
        <div class="ca-header-icon">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#E86A10" stroke-width="2"/>
            <circle cx="12" cy="12" r="3" stroke="#E86A10" stroke-width="2"/>
          </svg>
        </div>
        <div class="ca-header-text">
          <div class="ca-header-title">Continuar Assistindo</div>
          <div class="ca-header-sub">Overlay ao retomar o vídeo</div>
        </div>
      </div>

      <div class="ca-actions">
        <button class="ca-btn-save" @click="updateSubmit()">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M19 21H5a2 2 0 01-2-2V5a2 2 0 012-2h11l5 5v11a2 2 0 01-2 2z" stroke="#fff" stroke-width="2.5" stroke-linejoin="round"/><path d="M17 21v-8H7v8M7 3v5h8" stroke="#fff" stroke-width="2.5"/></svg>
          Salvar alterações
        </button>
        <router-link :to="`/player/${vslId}/customizacao`" class="ca-btn-back">
          <svg width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M19 12H5M12 19l-7-7 7-7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Voltar
        </router-link>
      </div>

      <div class="ca-body" v-if="viewer && viewer[0]">

        <!-- ── Disposição do Overlay ── -->
        <div class="ca-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><rect x="3" y="3" width="18" height="18" rx="3" stroke="#E86A10" stroke-width="2"/><path d="M3 9h18" stroke="#E86A10" stroke-width="2"/></svg>
          Disposição do Overlay
        </div>

        <div class="ca-card ca-layout-picker">
          <div
            v-for="layout in layouts"
            :key="layout.id"
            class="ca-layout-opt"
            :class="{ 'ca-layout-opt-active': selectedLayout === layout.id }"
            @click="selectedLayout = layout.id"
          >
            <div class="ca-layout-thumb">
              <!-- Miniatura visual de cada layout -->
              <div class="ca-lt-screen">
                <div class="ca-lt-bg"></div>
                <div class="ca-lt-ol" :class="'ca-lt-ol-' + layout.id"></div>
              </div>
            </div>
            <span class="ca-layout-name">{{ layout.name }}</span>
          </div>
        </div>

        <!-- ── Mensagem ── -->
        <div class="ca-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="#E86A10" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
          Mensagem principal
        </div>

        <div class="ca-card">
          <div class="ca-text-field">
            <label class="ca-text-label">Texto exibido ao usuário</label>
            <textarea
              v-model="viewer[0].viewer_message"
              class="ca-textarea"
              rows="3"
              placeholder="Ex: Você parou em 2:35. O que deseja fazer?"
            />
          </div>
        </div>

        <!-- ── Botões ── -->
        <div class="ca-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><rect x="3" y="8" width="18" height="8" rx="4" stroke="#E86A10" stroke-width="2"/></svg>
          Textos dos Botões
        </div>

        <div class="ca-card">
          <div class="ca-input-field">
            <label class="ca-input-label">
              <span class="ca-input-badge ca-badge-green">▶</span>
              Botão Continuar
            </label>
            <input
              v-model="viewer[0].viewer_bt_continue"
              type="text"
              class="ca-input"
              placeholder="Ex: Continuar de onde parei"
            >
          </div>
          <div class="ca-card-sep"></div>
          <div class="ca-input-field">
            <label class="ca-input-label">
              <span class="ca-input-badge ca-badge-blue">↺</span>
              Botão Recomeçar
            </label>
            <input
              v-model="viewer[0].viewer_bt_restart"
              type="text"
              class="ca-input"
              placeholder="Ex: Recomeçar do início"
            >
          </div>
        </div>

        <!-- ── Transparência ── -->
        <div class="ca-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><path d="M12 2v20M2 12h20" stroke="#E86A10" stroke-width="1.5" stroke-linecap="round" opacity="0.5"/></svg>
          Transparência do Overlay
        </div>

        <div class="ca-card">
          <div class="ca-slider-field">
            <div class="ca-slider-top">
              <span class="ca-slider-label">Opacidade</span>
              <span class="ca-slider-val">{{ overlayOpacity }}%</span>
            </div>
            <input
              type="range"
              min="10"
              max="100"
              step="5"
              v-model.number="overlayOpacity"
              class="ca-range"
            />
            <div class="ca-slider-hints">
              <span>Transparente</span>
              <span>Sólido</span>
            </div>
          </div>
        </div>

        <!-- ── Cores ── -->
        <div class="ca-section-label">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#E86A10" stroke-width="2"/><circle cx="12" cy="12" r="4" fill="#E86A10"/></svg>
          Identidade Visual
        </div>

        <div class="ca-card">
          <div class="ca-color-row">
            <div class="ca-color-meta">
              <div class="ca-color-name">Cor do Texto</div>
              <div class="ca-color-sub">Mensagem e labels dos botões</div>
            </div>
            <label class="ca-color-picker-wrap">
              <span class="ca-color-swatch" :style="'background:' + viewer[0].viewer_color_text"></span>
              <span class="ca-color-hex-val">{{ viewer[0].viewer_color_text }}</span>
              <svg class="ca-color-edit-icon" width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              <input type="color" v-model="viewer[0].viewer_color_text" class="ca-color-native">
            </label>
          </div>
          <div class="ca-card-sep"></div>
          <div class="ca-color-row">
            <div class="ca-color-meta">
              <div class="ca-color-name">Cor do Overlay</div>
              <div class="ca-color-sub">Fundo da tela de retomada</div>
            </div>
            <label class="ca-color-picker-wrap">
              <span class="ca-color-swatch" :style="'background:' + viewer[0].viewer_back_color"></span>
              <span class="ca-color-hex-val">{{ viewer[0].viewer_back_color }}</span>
              <svg class="ca-color-edit-icon" width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M11 4H4a2 2 0 00-2 2v14a2 2 0 002 2h14a2 2 0 002-2v-7M18.5 2.5a2.121 2.121 0 013 3L12 15l-4 1 1-4 9.5-9.5z" stroke="#94a3b8" stroke-width="2" stroke-linecap="round"/></svg>
              <input type="color" v-model="viewer[0].viewer_back_color" class="ca-color-native">
            </label>
          </div>
        </div>

      </div>
    </aside>

    <!-- ═══ PREVIEW ═══ -->
    <main class="ca-preview-area">

      <div class="ca-preview-chrome">
        <div class="ca-chrome-dots">
          <span class="ca-dot ca-dot-red"></span>
          <span class="ca-dot ca-dot-yellow"></span>
          <span class="ca-dot ca-dot-green"></span>
        </div>
        <div class="ca-chrome-title">
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="#E86A10" stroke-width="2"/><circle cx="12" cy="12" r="3" stroke="#E86A10" stroke-width="2"/></svg>
          Preview — Tela de Retomada
        </div>
        <span class="ca-live-pill">
          <span class="ca-live-dot"></span>
          AO VIVO
        </span>
      </div>

      <div class="ca-player-wrap">

        <!-- Fundo do player -->
        <video
          v-if="dadosVideo && dadosVideo.URL"
          class="ca-bg-video"
          :src="dadosVideo.URL"
          muted
          autoplay
          loop
          playsinline
        />
        <img
          v-else-if="dadosVideo && dadosVideo.thumb && dadosVideo.thumb.thumbStart"
          class="ca-bg-img"
          :src="dadosVideo.thumb.thumbStart"
          alt="thumb"
        />
        <div v-else class="ca-bg-dark" />

        <!-- Overlay dinâmico (muda conforme selectedLayout) -->
        <div
          v-if="viewer && viewer[0]"
          class="ca-overlay"
          :class="'ca-layout-' + selectedLayout"
          :style="overlayBgStyle"
        >

          <!-- LAYOUT 1 — Tela Cheia (centered, full) -->
          <template v-if="selectedLayout === 1">
            <div class="ca-overlay-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none">
                <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                <circle cx="12" cy="12" r="3" fill="rgba(255,255,255,0.7)"/>
              </svg>
            </div>
            <p class="ca-overlay-msg" :style="'color:' + viewer[0].viewer_color_text">
              {{ viewer[0].viewer_message || 'Você já começou a assistir. O que deseja fazer?' }}
            </p>
            <div class="ca-overlay-btns">
              <div class="ca-overlay-btn ca-overlay-btn-primary" :style="'border-color:' + viewer[0].viewer_color_text + '; color:' + viewer[0].viewer_color_text">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M5 3l14 9-14 9V3z" :fill="viewer[0].viewer_color_text"/></svg>
                {{ viewer[0].viewer_bt_continue || 'Continuar' }}
              </div>
              <div class="ca-overlay-btn ca-overlay-btn-ghost" :style="'color:' + viewer[0].viewer_color_text">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none"><path d="M1 4v6h6M23 20v-6h-6" stroke="rgba(255,255,255,0.7)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.49 9A9 9 0 005.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 013.51 15" stroke="rgba(255,255,255,0.7)" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {{ viewer[0].viewer_bt_restart || 'Recomeçar' }}
              </div>
            </div>
          </template>

          <!-- LAYOUT 2 — Faixa Inferior (bottom bar) -->
          <template v-if="selectedLayout === 2">
            <div class="ca-l2-row">
              <div class="ca-l2-left">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="rgba(255,255,255,0.7)" stroke-width="1.5"/>
                  <circle cx="12" cy="12" r="3" fill="rgba(255,255,255,0.7)"/>
                </svg>
                <p class="ca-l2-msg" :style="'color:' + viewer[0].viewer_color_text">
                  {{ viewer[0].viewer_message || 'Você já começou a assistir. O que deseja fazer?' }}
                </p>
              </div>
              <div class="ca-l2-btns">
                <div class="ca-l2-btn ca-l2-btn-primary" :style="'border-color:' + viewer[0].viewer_color_text + '; color:' + viewer[0].viewer_color_text">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M5 3l14 9-14 9V3z" :fill="viewer[0].viewer_color_text"/></svg>
                  {{ viewer[0].viewer_bt_continue || 'Continuar' }}
                </div>
                <div class="ca-l2-btn ca-l2-btn-ghost" :style="'color:' + viewer[0].viewer_color_text">
                  <svg width="13" height="13" viewBox="0 0 24 24" fill="none"><path d="M1 4v6h6M23 20v-6h-6" stroke="rgba(255,255,255,0.6)" stroke-width="2" stroke-linecap="round"/></svg>
                  {{ viewer[0].viewer_bt_restart || 'Recomeçar' }}
                </div>
              </div>
            </div>
          </template>

          <!-- LAYOUT 3 — Card Central (modal card, background visible) -->
          <template v-if="selectedLayout === 3">
            <div class="ca-l3-card" :style="cardBgStyle">
              <div class="ca-l3-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" stroke="rgba(255,255,255,0.8)" stroke-width="1.5"/>
                  <circle cx="12" cy="12" r="3" fill="rgba(255,255,255,0.8)"/>
                </svg>
              </div>
              <p class="ca-l3-msg" :style="'color:' + viewer[0].viewer_color_text">
                {{ viewer[0].viewer_message || 'Você já começou a assistir. O que deseja fazer?' }}
              </p>
              <div class="ca-l3-btns">
                <div class="ca-l3-btn ca-l3-btn-primary" :style="'background:' + viewer[0].viewer_color_text">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M5 3l14 9-14 9V3z" fill="currentColor"/></svg>
                  {{ viewer[0].viewer_bt_continue || 'Continuar' }}
                </div>
                <div class="ca-l3-btn ca-l3-btn-ghost" :style="'color:' + viewer[0].viewer_color_text + '; border-color: rgba(255,255,255,0.3)'">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M1 4v6h6M23 20v-6h-6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M20.49 9A9 9 0 005.64 5.64L1 10M23 14l-4.64 4.36A9 9 0 013.51 15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>
                  {{ viewer[0].viewer_bt_restart || 'Recomeçar' }}
                </div>
              </div>
            </div>
          </template>

        </div>
      </div>

    </main>

  </div>
</template>

<script>

import { ViewerService } from '@/services/Viewer'

export default {
  components: {},
  data() {
    return {
      VUE_APP_HOST_API_BACKEND: process.env.VUE_APP_HOST_API_BACKEND || '/api/dkbackend',
      vslId: this.$route.params.vslId,
      loading: false,
      viewer: [],
      dadosVideo: null,
      errorMessage: null,
      selectedLayout: 1,
      overlayOpacity: 85,
      layouts: [
        { id: 1, name: 'Tela Cheia' },
        { id: 2, name: 'Faixa Inferior' },
        { id: 3, name: 'Card Central' },
      ],
    }
  },
  computed: {
    overlayBgStyle() {
      if (!this.viewer || !this.viewer[0]) return {}
      const hex = this.viewer[0].viewer_back_color || '#cc0000'
      const alpha = Math.round((this.overlayOpacity / 100) * 255).toString(16).padStart(2, '0')
      if (this.selectedLayout === 3) {
        return { background: 'transparent' }
      }
      return { backgroundColor: hex + alpha }
    },
    cardBgStyle() {
      if (!this.viewer || !this.viewer[0]) return {}
      const hex = this.viewer[0].viewer_back_color || '#0a1520'
      const alpha = Math.round((this.overlayOpacity / 100) * 255).toString(16).padStart(2, '0')
      return { backgroundColor: hex + alpha }
    },
  },
  async created() {
    try {
      this.loading = true
      const response = await ViewerService.getViewerVSL_Id(this.vslId)
      this.viewer = response.data
      if (this.viewer && this.viewer[0]) {
        if (this.viewer[0].viewer_layout) {
          this.selectedLayout = Number(this.viewer[0].viewer_layout) || 1
        }
        if (this.viewer[0].viewer_opacity) {
          this.overlayOpacity = Number(this.viewer[0].viewer_opacity) || 85
        }
      }
      this.loading = false
    } catch (error) {
      this.errorMessage = error
      this.loading = false
    }
  },
  beforeMount() {
    this.jsonPersonalizado()
  },
  methods: {
    jsonPersonalizado() {
      const url = `${this.VUE_APP_HOST_API_BACKEND}/vslsInner/${this.vslId}`
      fetch(url)
        .then(response => response.json())
        .then(data => {
          if (data.status == '1') {
            this.dadosVideo = data.json.find(item => String(item.id) === String(this.vslId))
          }
        })
    },
    updateSubmit() {
      fetch(`${this.VUE_APP_HOST_API_BACKEND}/viewer/${this.vslId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          viewer_message: this.viewer[0].viewer_message,
          viewer_bt_restart: this.viewer[0].viewer_bt_restart,
          viewer_bt_continue: this.viewer[0].viewer_bt_continue,
          viewer_back_color: this.viewer[0].viewer_back_color,
          viewer_color_text: this.viewer[0].viewer_color_text,
          viewer_layout: this.selectedLayout,
          viewer_opacity: this.overlayOpacity,
          id_vsl: this.vslId,
        }),
      })
        .then(() => {
          this.$message({ type: 'success', message: 'Salvo com sucesso' })
        })
        .catch(err => console.error(err))
    },
  },
}

</script>

<style scoped>

.ca-root {
  display: flex;
  flex-direction: row;
  height: calc(100vh - 80px);
  background: var(--dk-bg-segment, #F0F3F7);
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
  overflow: hidden;
  --dk-bg-segment:     rgba(255,255,255,0.04);
  --dk-bg-card:        rgba(255,255,255,0.05);
  --dk-bg-page:        rgba(255,255,255,0.04);
  --dk-border:         rgba(255,255,255,0.09);
  --dk-border-light:   rgba(255,255,255,0.07);
  --dk-text-primary:   #e2e8f0;
  --dk-text-secondary: rgba(255,255,255,0.6);
  --dk-text-muted:     rgba(255,255,255,0.4);
  --dk-text-faint:     rgba(255,255,255,0.25);
}

/* ── Sidebar ── */
.ca-sidebar {
  width: 308px;
  min-width: 300px;
  max-width: 320px;
  background: var(--dk-bg-card, #fff);
  border-right: 1px solid var(--dk-border, #E4EAF0);
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  box-shadow: 2px 0 16px rgba(0,0,0,0.3);
}

.ca-header {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 20px 20px 16px;
  border-bottom: 1px solid var(--dk-border-light, #F0F3F7);
  flex-shrink: 0;
}
.ca-header-icon {
  width: 40px; height: 40px;
  border-radius: 12px;
  background: rgba(232,106,16,0.10);
  display: flex; align-items: center; justify-content: center;
  flex-shrink: 0;
}
.ca-header-text { flex: 1; min-width: 0; }
.ca-header-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--dk-text-primary, #0D3349);
  line-height: 1.2;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.ca-header-sub { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-top: 2px; }

.ca-actions {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  border-bottom: 1px solid var(--dk-border-light, #F0F3F7);
  flex-shrink: 0;
}
.ca-btn-save {
  flex: 1;
  display: inline-flex; align-items: center; justify-content: center;
  gap: 6px;
  background: #E86A10 !important; background-image: none !important;
  color: #fff !important;
  border: none; border-radius: 10px;
  padding: 10px 14px;
  font-size: 13px; font-weight: 600;
  cursor: pointer;
  box-shadow: 0 2px 10px rgba(232,106,16,0.30);
  transition: all 0.18s;
}
.ca-btn-save:hover { background: #c85a08 !important; box-shadow: 0 4px 16px rgba(232,106,16,0.40); transform: translateY(-1px); }
.ca-btn-back {
  display: inline-flex; align-items: center; justify-content: center;
  gap: 6px;
  background: var(--dk-bg-segment, #F4F6F9) !important; background-image: none !important;
  color: var(--dk-text-secondary, #64748b) !important;
  border: 1.5px solid var(--dk-border, #E4EAF0); border-radius: 10px;
  padding: 10px 16px;
  font-size: 13px; font-weight: 500;
  cursor: pointer; text-decoration: none !important;
  transition: all 0.15s; white-space: nowrap;
}
.ca-btn-back:hover { background: rgba(255,255,255,0.08) !important; color: #e2e8f0 !important; text-decoration: none !important; }

.ca-body { padding: 14px 16px; flex: 1; display: flex; flex-direction: column; }

.ca-section-label {
  display: flex; align-items: center; gap: 6px;
  font-size: 10.5px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.09em;
  color: var(--dk-text-muted, #94a3b8);
  margin: 14px 0 8px;
}
.ca-section-label:first-child { margin-top: 4px; }

.ca-card {
  background: var(--dk-bg-card, #fff);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 4px;
}
.ca-card-sep { height: 1px; background: var(--dk-bg-segment, #F0F3F7); }

/* ── Layout picker ── */
.ca-layout-picker {
  display: flex;
  gap: 0;
  padding: 12px;
  gap: 8px;
  overflow: visible;
}
.ca-layout-opt {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  border-radius: 10px;
  padding: 8px 6px;
  border: 2px solid var(--dk-border, #E4EAF0);
  background: var(--dk-bg-page, #F8FAFB);
  transition: all 0.15s;
}
.ca-layout-opt:hover { border-color: #E86A10; background: rgba(232,106,16,0.06); }
.ca-layout-opt-active {
  border-color: #E86A10 !important;
  background: rgba(232,106,16,0.08) !important;
  box-shadow: 0 0 0 3px rgba(232,106,16,0.12);
}
.ca-layout-thumb {
  width: 100%;
  aspect-ratio: 16/9;
  background: #1a2535;
  border-radius: 6px;
  overflow: hidden;
  position: relative;
}
.ca-lt-screen { position: absolute; inset: 0; }
.ca-lt-bg { position: absolute; inset: 0; background: linear-gradient(135deg,#1a2535,#0d1a28); }

/* Layout 1 miniatura - tela cheia */
.ca-lt-ol-1 {
  position: absolute; inset: 0;
  background: rgba(200,40,40,0.75);
  display: flex; align-items: center; justify-content: center;
}
.ca-lt-ol-1::after {
  content: '';
  width: 40%; height: 30%;
  border: 1.5px solid rgba(255,255,255,0.5);
  border-radius: 3px;
}

/* Layout 2 miniatura - faixa inferior */
.ca-lt-ol-2 {
  position: absolute; bottom: 0; left: 0; right: 0;
  height: 35%;
  background: rgba(200,40,40,0.85);
}

/* Layout 3 miniatura - card central */
.ca-lt-ol-3 {
  position: absolute;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  width: 55%; height: 55%;
  background: rgba(200,40,40,0.9);
  border-radius: 3px;
}

.ca-layout-name {
  font-size: 10px;
  font-weight: 600;
  color: var(--dk-text-secondary, #475569);
  text-align: center;
  white-space: nowrap;
}
.ca-layout-opt-active .ca-layout-name { color: #E86A10; }

/* ── Fields ── */
.ca-text-field { padding: 14px 16px; }
.ca-text-label {
  display: block;
  font-size: 11.5px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: var(--dk-text-muted, #94a3b8); margin-bottom: 8px;
}
.ca-textarea {
  width: 100%;
  border: 1.5px solid var(--dk-border, #E4EAF0); border-radius: 9px;
  padding: 10px 12px;
  font-size: 13px; color: var(--dk-text-primary, #0D3349); background: var(--dk-bg-page, #F8FAFB);
  resize: vertical; outline: none;
  transition: border-color 0.15s, box-shadow 0.15s;
  font-family: inherit; line-height: 1.5;
  box-sizing: border-box;
}
.ca-textarea:focus { border-color: #E86A10; background: var(--dk-bg-card, #fff); box-shadow: 0 0 0 3px rgba(232,106,16,0.10); }
.ca-textarea::placeholder { color: var(--dk-text-faint, #c0c8d4); }

.ca-input-field { padding: 12px 16px; }
.ca-input-label { display: flex; align-items: center; gap: 6px; font-size: 11.5px; font-weight: 600; color: var(--dk-text-secondary, #64748b); margin-bottom: 7px; }
.ca-input-badge {
  display: inline-flex; align-items: center; justify-content: center;
  width: 20px; height: 20px; border-radius: 5px; font-size: 10px; font-weight: 700;
}
.ca-badge-green { background: rgba(16,185,129,0.15); color: #34d399; }
.ca-badge-blue  { background: rgba(59,130,246,0.15); color: #60a5fa; }
.ca-input {
  width: 100%;
  border: 1.5px solid var(--dk-border, #E4EAF0); border-radius: 9px;
  padding: 9px 12px;
  font-size: 13px; color: var(--dk-text-primary, #0D3349); background: var(--dk-bg-page, #F8FAFB);
  outline: none; transition: border-color 0.15s, box-shadow 0.15s;
  font-family: inherit; box-sizing: border-box;
}
.ca-input:focus { border-color: #E86A10; background: var(--dk-bg-card, #fff); box-shadow: 0 0 0 3px rgba(232,106,16,0.10); }
.ca-input::placeholder { color: var(--dk-text-faint, #c0c8d4); }

/* Colors */
.ca-color-row { display: flex; align-items: center; justify-content: space-between; padding: 13px 16px; gap: 12px; }
.ca-color-meta { flex: 1; }
.ca-color-name { font-size: 13px; font-weight: 600; color: var(--dk-text-primary, #0D3349); }
.ca-color-sub { font-size: 11px; color: var(--dk-text-muted, #94a3b8); margin-top: 1px; }
.ca-color-picker-wrap {
  display: flex; align-items: center; gap: 7px;
  background: var(--dk-bg-page, #F8FAFB); border: 1.5px solid #E4EAF0; border-radius: 9px;
  padding: 6px 10px; cursor: pointer;
  position: relative; transition: border-color 0.15s, box-shadow 0.15s;
}
.ca-color-picker-wrap:hover { border-color: #E86A10; box-shadow: 0 0 0 3px rgba(232,106,16,0.10); }
.ca-color-swatch { width: 22px; height: 22px; border-radius: 6px; border: 1.5px solid rgba(0,0,0,0.08); display: block; flex-shrink: 0; }
.ca-color-hex-val { font-size: 12px; font-family: 'Courier New', monospace; font-weight: 600; color: var(--dk-text-secondary, #475569); letter-spacing: 0.02em; }
.ca-color-edit-icon { opacity: 0.45; flex-shrink: 0; }
.ca-color-native { position: absolute; opacity: 0; width: 100%; height: 100%; top: 0; left: 0; cursor: pointer; border: none; padding: 0; }

/* ── Slider ── */
.ca-slider-field { padding: 14px 16px; }
.ca-slider-top {
  display: flex; align-items: center; justify-content: space-between;
  margin-bottom: 10px;
}
.ca-slider-label {
  font-size: 12px; font-weight: 600; color: var(--dk-text-secondary, #475569);
}
.ca-slider-val {
  font-size: 12px; font-weight: 700;
  color: #E86A10;
  background: rgba(232,106,16,0.10);
  padding: 2px 8px; border-radius: 6px;
  font-family: 'Courier New', monospace;
}
.ca-range {
  -webkit-appearance: none;
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, #E86A10 0%, #E86A10 calc(var(--pct, 75) * 1%), rgba(255,255,255,0.15) calc(var(--pct, 75) * 1%), rgba(255,255,255,0.15) 100%);
  border-radius: 4px;
  outline: none;
  cursor: pointer;
}
.ca-range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 18px; height: 18px;
  border-radius: 50%;
  background: #E86A10;
  border: 2px solid var(--dk-bg-card, #fff);
  box-shadow: 0 1px 6px rgba(232,106,16,0.35);
  cursor: pointer;
  transition: box-shadow 0.15s;
}
.ca-range::-webkit-slider-thumb:hover {
  box-shadow: 0 2px 10px rgba(232,106,16,0.50);
}
.ca-range::-moz-range-thumb {
  width: 18px; height: 18px;
  border-radius: 50%;
  background: #E86A10;
  border: 2px solid var(--dk-bg-card, #fff);
  box-shadow: 0 1px 6px rgba(232,106,16,0.35);
  cursor: pointer;
}
.ca-slider-hints {
  display: flex; justify-content: space-between;
  font-size: 10px; color: var(--dk-text-muted, #94a3b8);
  margin-top: 5px;
}

/* ── Preview Area ── */
.ca-preview-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 16px 20px;
  background: var(--dk-bg-segment, #F0F3F7);
  min-width: 0;
  overflow: hidden;
}

.ca-preview-chrome {
  display: flex; align-items: center; gap: 10px;
  background: var(--dk-bg-card, #fff);
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-bottom: none;
  border-radius: 12px 12px 0 0;
  padding: 10px 16px;
  flex-shrink: 0;
}
.ca-chrome-dots { display: flex; gap: 6px; align-items: center; }
.ca-dot { width: 11px; height: 11px; border-radius: 50%; display: block; }
.ca-dot-red    { background: #ff5f57; }
.ca-dot-yellow { background: #febc2e; }
.ca-dot-green  { background: #28c840; }
.ca-chrome-title {
  display: flex; align-items: center; gap: 5px;
  font-size: 11.5px; font-weight: 700;
  text-transform: uppercase; letter-spacing: 0.07em;
  color: var(--dk-text-muted, #94a3b8); flex: 1;
}
.ca-live-pill {
  display: flex; align-items: center; gap: 5px;
  font-size: 10px; font-weight: 700; letter-spacing: 0.06em;
  color: #34d399; background: rgba(16,185,129,0.15);
  padding: 3px 9px; border-radius: 20px;
}
.ca-live-dot {
  width: 7px; height: 7px; border-radius: 50%;
  background: #34d399;
  animation: ca-pulse 1.4s ease-in-out infinite;
}
@keyframes ca-pulse { 0%, 100% { opacity: 1; } 50% { opacity: 0.3; } }

/* ── Player wrap — preenche toda a altura disponível ── */
.ca-player-wrap {
  flex: 1;
  background: #0a1520;
  border-radius: 0 0 12px 12px;
  overflow: hidden;
  border: 1.5px solid var(--dk-border, #E4EAF0);
  border-top: none;
  box-shadow: 0 12px 40px rgba(0,0,0,0.4);
  position: relative;
  min-height: 0;
}

/* Fundo vídeo/img/escuro */
.ca-bg-video,
.ca-bg-img,
.ca-bg-dark {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.ca-bg-dark { background: #0a1520; }

/* ══════════════════════════════
   OVERLAY — 3 LAYOUTS
   ══════════════════════════════ */

/* ── LAYOUT 1: Tela Cheia ── */
.ca-overlay.ca-layout-1 {
  position: absolute; inset: 0;
  display: flex; flex-direction: column;
  align-items: center; justify-content: center;
  gap: 18px; padding: 40px;
}

.ca-overlay-icon {
  width: 60px; height: 60px; border-radius: 50%;
  background: rgba(255,255,255,0.12);
  border: 1.5px solid rgba(255,255,255,0.25);
  display: flex; align-items: center; justify-content: center;
}
.ca-overlay-msg {
  font-size: 18px; font-weight: 600;
  text-align: center; margin: 0; line-height: 1.4;
  max-width: 520px;
  text-shadow: 0 1px 6px rgba(0,0,0,0.3);
}
.ca-overlay-progress-wrap {
  display: flex; align-items: center; gap: 10px;
  width: 100%; max-width: 420px;
}
.ca-overlay-progress-bar {
  flex: 1; height: 4px;
  background: rgba(255,255,255,0.2); border-radius: 4px; overflow: hidden;
}
.ca-overlay-progress-fill { height: 100%; width: 30%; border-radius: 4px; opacity: 0.85; }
.ca-overlay-progress-label { font-size: 12px; font-weight: 600; opacity: 0.75; white-space: nowrap; }
.ca-overlay-btns { display: flex; gap: 12px; flex-wrap: wrap; justify-content: center; }
.ca-overlay-btn {
  display: flex; align-items: center; gap: 8px;
  padding: 12px 24px; border-radius: 50px;
  font-size: 14px; font-weight: 600;
  cursor: pointer; transition: all 0.18s;
}
.ca-overlay-btn-primary {
  background: rgba(255,255,255,0.15);
  border: 2px solid currentColor;
  backdrop-filter: blur(4px);
}
.ca-overlay-btn-primary:hover { background: rgba(255,255,255,0.25); }
.ca-overlay-btn-ghost {
  background: rgba(255,255,255,0.06);
  border: 2px solid rgba(255,255,255,0.3);
}
.ca-overlay-btn-ghost:hover { background: rgba(255,255,255,0.14); }

/* ── LAYOUT 2: Faixa Inferior ── */
.ca-overlay.ca-layout-2 {
  position: absolute; bottom: 0; left: 0; right: 0;
  display: flex; flex-direction: column;
  gap: 8px; padding: 12px 20px 16px;
}
.ca-l2-progress-wrap { display: flex; align-items: center; gap: 10px; }
.ca-l2-progress-bar { flex: 1; height: 3px; background: rgba(255,255,255,0.2); border-radius: 4px; overflow: hidden; }
.ca-l2-progress-fill { height: 100%; width: 30%; border-radius: 4px; opacity: 0.85; }
.ca-l2-time { font-size: 11px; font-weight: 600; opacity: 0.75; white-space: nowrap; }
.ca-l2-row { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.ca-l2-left { display: flex; align-items: center; gap: 10px; flex: 1; min-width: 0; }
.ca-l2-msg {
  font-size: 13px; font-weight: 600; margin: 0;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
  text-shadow: 0 1px 3px rgba(0,0,0,0.3);
}
.ca-l2-btns { display: flex; gap: 8px; flex-shrink: 0; }
.ca-l2-btn {
  display: flex; align-items: center; gap: 6px;
  padding: 8px 16px; border-radius: 50px;
  font-size: 12px; font-weight: 600;
  cursor: pointer; transition: all 0.15s; white-space: nowrap;
}
.ca-l2-btn-primary { background: rgba(255,255,255,0.18); border: 1.5px solid currentColor; backdrop-filter: blur(4px); }
.ca-l2-btn-primary:hover { background: rgba(255,255,255,0.28); }
.ca-l2-btn-ghost { background: rgba(255,255,255,0.05); border: 1.5px solid rgba(255,255,255,0.25); }
.ca-l2-btn-ghost:hover { background: rgba(255,255,255,0.12); }

/* ── LAYOUT 3: Card Central ── */
.ca-overlay.ca-layout-3 {
  position: absolute; inset: 0;
  display: flex; align-items: center; justify-content: center;
  background: transparent;
}
.ca-l3-card {
  background: rgba(10,21,32,0.88);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  border: 1.5px solid rgba(255,255,255,0.12);
  border-radius: 18px;
  padding: 28px 32px;
  display: flex; flex-direction: column; align-items: center;
  gap: 14px; text-align: center;
  max-width: 440px; width: 90%;
  box-shadow: 0 20px 60px rgba(0,0,0,0.6);
}
.ca-l3-icon {
  width: 52px; height: 52px; border-radius: 50%;
  background: rgba(255,255,255,0.10);
  border: 1.5px solid rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
}
.ca-l3-msg {
  font-size: 15px; font-weight: 600; margin: 0; line-height: 1.45;
  text-shadow: none;
}
.ca-l3-progress-wrap { display: flex; align-items: center; gap: 10px; width: 100%; }
.ca-l3-progress-bar { flex: 1; height: 4px; background: rgba(255,255,255,0.15); border-radius: 4px; overflow: hidden; }
.ca-l3-progress-fill { height: 100%; width: 30%; border-radius: 4px; opacity: 0.85; }
.ca-l3-time { font-size: 11px; font-weight: 600; opacity: 0.7; white-space: nowrap; }
.ca-l3-btns { display: flex; gap: 10px; }
.ca-l3-btn {
  display: flex; align-items: center; gap: 7px;
  padding: 10px 20px; border-radius: 50px;
  font-size: 13px; font-weight: 600;
  cursor: pointer; transition: all 0.15s;
}
.ca-l3-btn-primary {
  color: #fff;
  box-shadow: 0 4px 14px rgba(0,0,0,0.3);
}
.ca-l3-btn-primary:hover { opacity: 0.9; transform: translateY(-1px); }
.ca-l3-btn-ghost {
  background: transparent;
  border: 1.5px solid;
}
.ca-l3-btn-ghost:hover { background: rgba(255,255,255,0.08); }

</style>
